import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { v4 } from 'uuid';

const db = firebase.firestore();

type StudiesState = {
  isLoading: boolean,
  isLoadingDelete: boolean,
  error: Error | string | null;
  allStudies: Array<any>;
  allStudiesCrm: Array<any>;
  allVersions: any;
  study: any;
  versionOpts: { value: string, label: string }[],
  groupVersion: any,
  infosFirstModal: any
};

const initialState: StudiesState = {
  isLoading: false,
  isLoadingDelete: false,
  error: null,
  allStudies: [],
  allVersions: [],
  study: null,
  versionOpts: [],
  groupVersion: null,
  infosFirstModal: null,
  allStudiesCrm: []
};

const slice = createSlice({
  name: 'studies',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    startLoadingDelete(state) {
      state.isLoadingDelete = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getStudiesAndVersionsSuccess(state, action) {
      state.allStudies = action.payload.studies;
      state.allVersions = action.payload.versions;
      state.isLoading = false;
    },

    getStudyByIdSuccess(state, action) {
      state.study = action.payload.study;
      state.versionOpts = action.payload.versionOpts;
      state.isLoading = false;
    },

    getGroupVersionByIdSuccess(state, action) {
      state.groupVersion = action.payload;
      state.isLoading = false;
    },

    saveInfosFirstModal(state, action) {
      state.infosFirstModal = { ...state.infosFirstModal, ...action.payload };
    },

    getAllStudiesCrm(state, action) {
      state.allStudiesCrm = action.payload;
      state.isLoading = false;
    },

    resetStudiesCrm(state) {
      state.allStudiesCrm = []
    },

    delete(state, action) {
      state.allStudiesCrm.map((study: any, idx: number) => {
        if (study.id === action.payload) {
          if (idx > -1) {
            state.allStudiesCrm.splice(idx, 1);
          }
        }
        return study;
      });
      state.isLoadingDelete = false;
    },

    deleteMany(state, action) {
      action.payload.map((study: any) => {
        state.allStudiesCrm.map((s: any, idx: number) => {
          if (s.id === study.id) {
            if (idx > -1) {
              state.allStudiesCrm.splice(idx, 1);
            }
          }
          return s;
        });
        return study;
      });
      state.isLoadingDelete = false;
    },

    editAllStudie(state, action) {
      state.allStudiesCrm.map((study: any, idx: number) => {
        if (study.id === action.payload.id) {
          state.allStudiesCrm[idx] = action.payload
        }
        return study;
      })
    }
  },
});

export const { startLoading } = slice.actions;

export default slice.reducer;

export function getStudiesAndVersions(uid: string) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      var studiesAux: any = [];
      var res = await db.collection("studies").doc(uid).collection('data').get()
      res.forEach(async (doc) => {
        var vCount = 0
        var resVersions = await db.collection("studies").doc(uid).collection('data').doc(doc.id).collection('versions').get()
        resVersions.forEach((rv) => {
          vCount = vCount + 1
        })
        studiesAux.push({ ...doc.data(), id: doc.id, versions: vCount })
      })

      var groupVersionsAux: any = []
      var resGroupVersions = await db.collection("versionsGroup").doc(uid).collection('data').get()
      resGroupVersions.forEach(async (doc) => {
        var vCount = 0;
        var studiesId: any = []
        var resGroupVersionsVersions = await db.collection("versionsGroup").doc(uid).collection('data').doc(doc.id).collection('versions').get()
        resGroupVersionsVersions.forEach((v) => {
          vCount = vCount + 1;
          studiesId.push(v.data().studyId)
        })
        let unique = studiesId.filter((v: any, i: any, a: any) => a.indexOf(v) === i);
        groupVersionsAux.push({
          ...doc.data(),
          versions: vCount,
          studies: unique.length,
        })
      })
      setTimeout(() => dispatch(slice.actions.getStudiesAndVersionsSuccess({ studies: studiesAux, versions: groupVersionsAux })), 1500)
    } catch (error) {
      return false
    }
  };
}

export function getAllStudies() {
  return async () => {
    try {
      dispatch(slice.actions.startLoading());
      var allStudies: any[] = [];
      var studies = await db.collection("studies").get()
      const promises: any = [];
      studies.forEach(async (doc) => {
        promises.push(getStudies(doc));
      });
      const resultados = await Promise.all(promises);
      if (resultados.length > 0) {
        resultados.forEach((estudos: any) => {
          if (estudos.length > 0) {
            allStudies = [...allStudies, ...estudos.map((study: any) => {
              if (!study.paymentStatus) {
                study.paymentStatus = "NONE"
              }
              return study;
            })];
          }
        });
      }
      dispatch(slice.actions.getAllStudiesCrm(allStudies));
    } catch (error) {
      return false
    }
  };
}

export function deleteStudy(uid: string, userid: string) {
  try {
    dispatch(slice.actions.startLoadingDelete());
    db.collection("studies").doc(userid).collection("data").doc(uid).delete();  
    dispatch(slice.actions.delete(uid));
  } catch (error) {
    console.error(error);
  }
}

export function deleteManyStudies(studies: any) {
  return async () => {
    try {
      dispatch(slice.actions.startLoadingDelete());
      const map = studies.map(async (study: any) =>
        await db.collection("studies").doc(study.userid).collection("data").doc(study.id).delete()
      )
      await Promise.all(map)
      dispatch(slice.actions.deleteMany(studies));
    } catch (error) {
      console.error(error);
    }
  };
}

const getStudies = async (doc: any) => {
  return new Promise(async function (resolve, reject) {
    try {
      const userStudies = await db.collection("studies").doc(doc.id).collection('data').get();
      const studies = userStudies.docs.map((study: any) => study.data());
      resolve(studies);
    } catch (error) {
      reject(error)
    }
  });
}

export function getStudyById(userUid: string, studyId: string) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      var resStudy = await db.collection("studies").doc(userUid).collection('data').doc(studyId).get()
      var resVersions = await db.collection("studies").doc(userUid).collection('data').doc(studyId).collection('versions').get()
      if (resStudy.exists) {
        var study: any = { ...resStudy.data(), versions: [] }
      }
      resVersions.forEach((version) => {
        study.versions.push(version.data())
      });
      var groups = await db.collection("versionsGroup").doc(userUid).collection('data').get()
      var versionOpts: any = []
      groups.forEach((group) => {
        versionOpts.push({ label: group.data().name, value: group.data().id })
      });
      setTimeout(() => dispatch(slice.actions.getStudyByIdSuccess({ study, versionOpts })), 1500)
    } catch (error) {
      return false
    }
  };
}

export function getGroupVersionById(userId: string, id: string) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      var resGroup = await db.collection("versionsGroup").doc(userId).collection('data').doc(id).get()
      var resVersions = await db.collection("versionsGroup").doc(userId).collection('data').doc(id).collection('versions').get()
      if (resGroup.exists) {
        var group: any = { ...resGroup.data(), versions: [] }
      }
      resVersions.forEach((v) => {
        group.versions.push(v.data())
      })
      setTimeout(() => dispatch(slice.actions.getGroupVersionByIdSuccess(group)), 1500)
    } catch (error) {
      return false
    }
  };
}

export function deleteVersion(userUid: string, studyId: string, versionsId: string[]) {
  return async () => {
    try {
      var resVersions = await db.collection("studies").doc(userUid).collection('data').doc(studyId).collection('versions').get()
      var arrayToDelete: any = []
      resVersions.forEach((v) => {
        if (versionsId.includes(v.data().id)) {
          arrayToDelete.push(v.id)
        }
      })
      const map = arrayToDelete.map(async (id: any) =>
        await db.collection("studies").doc(userUid).collection('data').doc(studyId).collection('versions').doc(id).delete()
      )
      await Promise.all(map)
    } catch (error) {
      console.log(error)
      return false
    }
  };
}

export function createVersionGroup(userUid: string, studyId: string, versionsId: string[], groupName: string) {
  return async () => {
    try {
      var idVersionGroup = v4();
      var resStudy = await db.collection("studies").doc(userUid).collection('data').doc(studyId).get()
      var resVersions = await db.collection("studies").doc(userUid).collection('data').doc(studyId).collection('versions').get()
      var auxVersions: any = {}
      if (resStudy.exists) {
        resVersions.forEach((v) => {
          if (versionsId.includes(v.data().id)) {
            auxVersions[v.id] = {
              ...v.data(),
              studyId: resStudy.data()?.id,
              studyImage: resStudy.data()?.image,
              studyName: resStudy.data()?.name,
              studyArea: resStudy.data()?.area,
              studyPerimeter: resStudy.data()?.perimeter,
            }
          }
        })
      }
      await db.collection("versionsGroup").doc(userUid).collection('data').doc(idVersionGroup).set({
        id: idVersionGroup,
        name: groupName
      })
      const map = Object.keys(auxVersions).map(async (key) => {
        await db.collection("versionsGroup").doc(userUid).collection('data').doc(idVersionGroup).collection('versions').doc(key).set(auxVersions[key])
      })
      await Promise.all(map)
    } catch (error) {
      console.log(error)
      return false
    }
  };
}

export function addToVersionGroup(userUid: string, studyId: string, versionsId: string[], groupVersionId: string) {
  return async () => {
    try {
      var verifica = await db.collection("versionsGroup").doc(userUid).collection('data').doc(groupVersionId).collection('versions').get()
      var versionsInCount = 0;

      verifica.forEach(() => {
        versionsInCount = versionsInCount + 1;
      })

      if ((versionsInCount + versionsId.length) > 4) {
        return 'erro'
      }

      var resStudy = await db.collection("studies").doc(userUid).collection('data').doc(studyId).get()
      var resVersions = await db.collection("studies").doc(userUid).collection('data').doc(studyId).collection('versions').get()
      var auxVersions: any = {}
      if (resStudy.exists) {
        resVersions.forEach((v) => {
          if (versionsId.includes(v.data().id)) {
            auxVersions[v.id] = {
              ...v.data(),
              studyId: resStudy.data()?.id,
              studyImage: resStudy.data()?.image,
              studyName: resStudy.data()?.name,
              studyArea: resStudy.data()?.area,
              studyLiquidArea: 2,
              studyPercentRestrictArea: 2,
              studyPerimeter: resStudy.data()?.perimeter,
            }
          }
        })
      }
      const map = Object.keys(auxVersions).map(async (key) => {
        await db.collection("versionsGroup").doc(userUid).collection('data').doc(groupVersionId).collection('versions').add(auxVersions[key])
      })
      await Promise.all(map)
    } catch (error) {
      console.log(error)
      return false
    }
  };
}

export function saveInfosFirstModal(data: any) {
  dispatch(slice.actions.saveInfosFirstModal(data));
}

export function editStudie(study: any) {
  return async () => {
    try {
      dispatch(slice.actions.editAllStudie(study));
      return true
    } catch (error) {
      console.log(error)
      return false
    }
  }
}

export const getDiscount = async (name: String): Promise<any> =>  {
  try {
    var foundDiscount = null;
    const discounts = await db.collection("discount").get();
    discounts.forEach((discount) => {
      if (discount.data().name == name && discount.data().status == true && discount.data().limit > discount.data().used) {
        foundDiscount = discount.data();
      }
    });
    return foundDiscount;
  } catch (error) {
    throw error;
  }
}
